module.exports = __webpack_public_path__ + "static/media/8.ee008373.jpeg";